module.exports = __webpack_public_path__ + "img/bl-bottom.c3100f45.png";